import axios from 'axios';

export const state = {
    calzado: [],
    size: []
}

export const getters = {
    getCalzado: (state) => state.calzado,
    getSize: (state) => state.size,
}

export const actions = {
    async fetchAllCalzado({ commit }) {
        const response = await axios.get(`/attribute/all/calzado`);
        commit('SET_ALL_CALZADO', {result: response.data});
    },
    async fetchAllSize({ commit }) {
        const response = await axios.get(`/attribute/all/size`);
        commit('SET_ALL_SIZE', {result: response.data});
    },
}


export const mutations = {
    SET_ALL_CALZADO: (state, {result}) => state.calzado = result,
    SET_ALL_SIZE: (state, {result}) => state.size = result
}